<template>
  <div
    class="profile-view w-screen h-screen flex flex-col items-center justify-center font-pixel overflow-hidden"
    :style="{ fontFamily: 'VT323, monospace', backgroundColor: '#4aa3a3', backgroundImage: `url(${desktopBackground})`, backgroundRepeat: 'repeat' }"
  >
    <div class="border-2 border-black bg-white shadow-pixel p-8 w-[560px] max-w-[90vw]">
      <!-- Hide the text until VT323 is loaded to prevent fallback-font flicker -->
      <div
        class="w-full transition-opacity duration-200"
        :class="fontLoaded ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'"
      >
        <p class="text-7xl font-bold text-black mb-4 text-center">Welcome</p>
        <p class="text-2xl text-black opacity-90 mb-8 text-center">
          Select a profile to proceed.
        </p>

        <button
          type="button"
          class="w-full flex flex-col items-center justify-center text-center px-8 py-8 border-2 border-black bg-gray-100 hover:bg-gray-200 font-pixel transition-all duration-200 cursor-pointer hover:-translate-y-0.5 hover:scale-[1.02]"
          @click="emit('select')"
        >
          <!-- Profile icon -->
          <svg
            class="w-20 h-20 mb-3 text-black flex-shrink-0"
            viewBox="0 0 32 32"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
          >
            <circle cx="16" cy="10" r="5" />
            <path d="M6 28 Q6 18 16 18 Q26 18 26 28" />
          </svg>
          <span class="text-3xl font-bold text-black">Saad</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import desktopBackground from '@/assets/desktop-bg2-924f1967-5752-4203-b00a-6c23628c74ea.png'

const emit = defineEmits(['select'])

const fontLoaded = ref(false)

onMounted(async () => {
  try {
    // Wait until the VT323 font is ready to avoid fallback-font flicker.
    // If `document.fonts` isn't available, we fall back to showing immediately.
    if (document.fonts) {
      if (!document.fonts.check('24px VT323')) {
        await document.fonts.load('24px VT323')
      }
    }
  } catch {
    // If loading fails for any reason, don't block the UI forever.
  } finally {
    fontLoaded.value = true
  }
})
</script>

